import classNames from "classnames";
import { useMemo } from "react";

const NotifyNotificationsStatusLabelType = {
  Pending: "Pending",
  Draft: "Draft",
  Scheduled: "Scheduled",
  Sending: "Sending",
  Active: "Active",
  Archived: "Archived",
  Rejected: "Rejected",
} as const;
type NotifyNotificationsStatusLabelType =
  (typeof NotifyNotificationsStatusLabelType)[keyof typeof NotifyNotificationsStatusLabelType];

export function NotifyNotificationsStatusLabel({ type: type }: { type: NotifyNotificationsStatusLabelType }) {
  const text = useMemo(() => {
    const labelTable = {
      [NotifyNotificationsStatusLabelType.Pending]: "Pending Approval",
      [NotifyNotificationsStatusLabelType.Draft]: "Draft",
      [NotifyNotificationsStatusLabelType.Scheduled]: "Scheduled",
      [NotifyNotificationsStatusLabelType.Sending]: "Sending",
      [NotifyNotificationsStatusLabelType.Active]: "Active",
      [NotifyNotificationsStatusLabelType.Archived]: "Expired",
      [NotifyNotificationsStatusLabelType.Rejected]: "Rejected",
    };
    return labelTable[type];
  }, [type]);

  const textColor = useMemo(() => {
    const colorTable = {
      [NotifyNotificationsStatusLabelType.Pending]: "tw-text-white",
      [NotifyNotificationsStatusLabelType.Draft]: "tw-text-text-secondary",
      [NotifyNotificationsStatusLabelType.Scheduled]: "tw-text-white",
      [NotifyNotificationsStatusLabelType.Sending]: "tw-text-[#067E30]",
      [NotifyNotificationsStatusLabelType.Active]: "tw-text-white",
      [NotifyNotificationsStatusLabelType.Archived]: "tw-text-white",
      [NotifyNotificationsStatusLabelType.Rejected]: "tw-text-white",
    };
    return colorTable[type];
  }, [type]);

  const bgColor = useMemo(() => {
    const bgColorTable = {
      [NotifyNotificationsStatusLabelType.Pending]: "tw-bg-[#104C61]",
      [NotifyNotificationsStatusLabelType.Draft]: "tw-bg-[#E3E3E3]",
      [NotifyNotificationsStatusLabelType.Scheduled]: "tw-bg-[#6434CA]",
      [NotifyNotificationsStatusLabelType.Sending]: "tw-bg-[#067e3033]",
      [NotifyNotificationsStatusLabelType.Active]: "tw-bg-[#067E30]",
      [NotifyNotificationsStatusLabelType.Archived]: "tw-bg-[#AA2222]",
      [NotifyNotificationsStatusLabelType.Rejected]: "tw-bg-[#AA2222]",
    };
    return bgColorTable[type];
  }, [type]);

  return (
    <div className='tw-flex tw-justify-start'>
      <div
        className={classNames(
          "tw-flex tw-h-6 tw-items-center tw-whitespace-nowrap tw-rounded-full tw-px-3 tw-text-[11px] tw-font-semibold tw-leading-none",
          textColor,
          bgColor,
        )}
      >
        {text}
      </div>
    </div>
  );
}
